module.exports = __webpack_public_path__ + "img/egyptbarracks_tech_Normal_ua.0598bfe6.webp";